import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { EwMaImageService } from './../../ew-ma-image.service';
@Component({
  selector: 'lib-unsplash-images',
  templateUrl: './unsplash-images.component.html',
  styleUrls: ['./unsplash-images.component.css'],
})
export class UnsplashImagesComponent implements OnInit {

  public page: number = 1;
  public limit: number = 15;
  public totalItems: number = 0;
  public images = [];
  selectedIndex: number = null;
  public searchQuery: string = '';
  public showLoader: boolean = false;
  public noImagesIconPath = "";

  /**
   * @description
   * Emit event to close dialog.
   */
  @Output() selectedImage: EventEmitter<any> = new EventEmitter();
  @Output() loaderShown: EventEmitter<any> = new EventEmitter();

  constructor(private ewMaImageService: EwMaImageService) {}

  ngOnInit(): void {
    this.getImages(1);
    this.loaderShown.emit(this.showLoader);
    this.noImagesIconPath = this.ewMaImageService.getResourceUrl("assets/images/Property-default.svg");

  }

  /**
   * @description
   * Get upcoming sessions list
   */
  getImages(page: number) {
    this.showLoader = true;
    this.loaderShown.emit(this.showLoader);
    this.page = page;
    const model = {
      page: page,
      per_page: this.limit,
      query: '',
    };
    if (this.searchQuery.length) {
      model.query = this.searchQuery;
      this.ewMaImageService.searchUnsplashImages(model).subscribe(
        (response: any) => {
          this.showLoader = false;
          this.loaderShown.emit(this.showLoader);
          if (response.total) {
            this.images = response.results;
            this.totalItems = response.total;
          } else {
            console.log('Error in api request');
            this.resetRecords();
          }
        },
        (error) => {
          this.showLoader = false;
          this.loaderShown.emit(this.showLoader);
          console.log('error', error);
          this.resetRecords();
        }
      );
    } else {
      this.ewMaImageService.getUnsplashImages(model).subscribe(
        (response: any) => {
          this.showLoader = false;
          this.loaderShown.emit(this.showLoader);
          if (response.length) {
            this.images = response;
            this.totalItems = 100;
          } else {
            console.log('Error in api request');
            this.resetRecords();
          }
        },
        (error) => {
          this.showLoader = false;
          this.loaderShown.emit(this.showLoader);
          console.log('error', error);
          this.resetRecords();
        }
      );
    }
  }

  resetRecords() {
    this.page = 1;
    this.images = [];
    this.totalItems = 0;
  }

  selectImage(image: any, index: number) {
    image.active = !image.active;
    this.selectedIndex = index;
    this.selectedImage.emit(image);
  }

  searchImage(search: string) {
    this.searchQuery = search;
    this.getImages(1);
  }
}
